import { useState, useEffect } from "react";
import { MapPin, Phone, Mail, Clock, Send } from "lucide-react";
import AOS from "aos";
import "aos/dist/aos.css";

export default function ContactPage() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  // useEffect(() => {
  //   AOS.init({ duration: 1000 });
  // }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form submitted:", formData);
    alert("Thank you for your message! We will get back to you soon.");
    setFormData({ name: "", email: "", phone: "", message: "" });
  };

  return (
    // <div className="min-h-screen py-20 px-4 max-w-7xl overflow-hidden mx-auto">
    <div className="overflow-hidden">
      {/* Header */}
      {/* <div
        className="text-center mb-16"
        data-aos="fade-down"
        style={{ backgroundColor: "brown" }}
      >
        <h1 className="text-5xl font-bold text-gray-900 mb-6">Contact Us</h1>
        <p className="text-xl text-gray-600 max-w-3xl mx-auto">
          Ready to start your project? Get in touch with our team for a free
          consultation and quote.
        </p>
      </div> */}
      <section
        className="relative h-72 md:h-96 flex items-center justify-center bg-center bg-cover"
        style={{
          backgroundImage:
            "url('https://tse3.mm.bing.net/th?id=OIP.dOyrog0Mjp1jK82qmgyi4QHaEK&pid=Api&P=0&h=180')",
        }}
      >
        {/* Dark Overlay */}
        {/* <div className="absolute inset-0 bg-black opacity-50"></div> */}

        {/* Text Content */}
        <div className="text-center mb-16">
          <h1
            className="text-5xl font-bold text-white mb-6"
            data-aos="fade-right"
          >
            Contact Us
          </h1>
          <p
            className="text-xl text-black max-w-3xl mx-auto"
            data-aos="fade-left"
          >
            Ready to start your project? Get in touch with our team for a free
            consultation and quote.
          </p>
        </div>
      </section>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mt-20">
        {/* Contact Form */}
        <div
          className="bg-white p-8 rounded-lg shadow-md"
          data-aos="fade-right"
        >
          <div className="inline-block">
            <h2 className="text-2xl font-semibold mb-1 text-blue-700">
              Send us a Message
            </h2>
            <div className="h-1 w-24 bg-[#6FEF34] mx-auto mb-3 blink-underline"></div>
          </div>

          <p className="text-gray-600 mb-6">
            Fill out the form below and we'll get back to you within 24 hours.
          </p>
          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label
                  htmlFor="name"
                  className="block text-sm font-medium mb-1"
                >
                  Full Name *
                </label>
                <input
                  id="name"
                  name="name"
                  type="text"
                  required
                  value={formData.name}
                  onChange={handleInputChange}
                  className="w-full border border-gray-300 rounded px-3 py-2"
                  placeholder="John Doe"
                />
              </div>
              <div>
                <label
                  htmlFor="phone"
                  className="block text-sm font-medium mb-1"
                >
                  Phone Number *
                </label>
                <input
                  id="phone"
                  name="phone"
                  type="tel"
                  required
                  value={formData.phone}
                  onChange={handleInputChange}
                  className="w-full border border-gray-300 rounded px-3 py-2"
                  placeholder="(555) 123-4567"
                />
              </div>
            </div>
            <div>
              <label htmlFor="email" className="block text-sm font-medium mb-1">
                Email Address *
              </label>
              <input
                id="email"
                name="email"
                type="email"
                required
                value={formData.email}
                onChange={handleInputChange}
                className="w-full border border-gray-300 rounded px-3 py-2"
                placeholder="john@example.com"
              />
            </div>
            <div>
              <label
                htmlFor="message"
                className="block text-sm font-medium mb-1"
              >
                Message *
              </label>
              <textarea
                id="message"
                name="message"
                required
                value={formData.message}
                onChange={handleInputChange}
                className="w-full border border-gray-300 rounded px-3 py-2 min-h-[120px]"
                placeholder="Tell us about your project..."
              ></textarea>
            </div>
            <button
              type="submit"
              className="w-full bg-blue-600 text-white py-3 rounded-lg flex items-center justify-center gap-2"
            >
              <Send className="w-4 h-4" /> Send Message
            </button>
          </form>
        </div>

        {/* Contact Info */}
        <div className="space-y-8">
          <div
            className="bg-white p-6 rounded-lg shadow-md space-y-6"
            data-aos="fade-left"
          >
            <div className="flex items-start gap-4">
              <MapPin className="h-6 w-6 text-blue-600 mt-1" />
              <div>
                <h3 className="font-semibold">Address</h3>
                <p className="text-gray-600">
                  123 Construction Avenue
                  <br />
                  Building District, City 12345
                  <br />
                  United States
                </p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <Phone className="h-6 w-6 text-blue-600 mt-1" />
              <div>
                <h3 className="font-semibold">Phone</h3>
                <p className="text-gray-600">
                  Main: (555) 123-4567
                  <br />
                  Emergency: (555) 987-6543
                </p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <Mail className="h-6 w-6 text-blue-600 mt-1" />
              <div>
                <h3 className="font-semibold">Email</h3>
                <p className="text-gray-600">
                  General: info@Sanctus property pvt ltd.com
                  <br />
                  Projects: projects@Sanctus property pvt ltd.com
                </p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <Clock className="h-6 w-6 text-blue-600 mt-1" />
              <div>
                <h3 className="font-semibold">Business Hours</h3>
                <p className="text-gray-600">
                  Mon - Fri: 8:00 AM - 6:00 PM
                  <br />
                  Saturday: 9:00 AM - 4:00 PM
                  <br />
                  Sunday: Closed
                </p>
              </div>
            </div>
          </div>

          {/* Map */}
          <div
            className="bg-white p-6 rounded-lg shadow-md"
            data-aos="zoom-in-up"
          >
            <h3 className="text-lg font-semibold mb-4">Find Us</h3>
            <div className="aspect-video bg-gray-200 rounded-lg overflow-hidden">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3024.1234567890123!2d-74.0059413!3d40.7127753!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDDCsDQyJzQ2LjAiTiA3NMKwMDAnMjEuNCJX!5e0!3m2!1sen!2sus!4v1234567890123"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                className="w-full h-full"
              ></iframe>
            </div>
          </div>

          {/* Emergency */}
          <div
            className="bg-red-50 border border-red-200 p-6 rounded-lg shadow-md"
            data-aos="flip-left"
          >
            <h3 className="text-lg font-semibold text-red-800 mb-2">
              Emergency Services
            </h3>
            <p className="text-red-600 mb-4">
              24/7 emergency construction and plumbing services available
            </p>
            <button className="w-full bg-red-600 text-white py-3 rounded-lg flex items-center justify-center gap-2">
              <Phone className="w-4 h-4" /> Call Emergency Line: (555) 911-HELP
            </button>
          </div>
        </div>
      </div>

      {/* FAQ */}
      <section className="mt-20 mb-20" data-aos="fade-up ">
        <div className="text-center mb-12">
          <div className="inline-block">
            <h2 className="text-2xl font-semibold mb-1 text-blue-700">
              Send us a Message
            </h2>
            <div className="h-1 w-24 bg-[#6FEF34] mx-auto mb-3 blink-underline"></div>
          </div>

          <p className="text-xl text-gray-600">
            Quick answers to common questions about our services
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {[
            {
              question: "How long does a typical project take?",
              answer:
                "Project timelines vary depending on scope and complexity. Small renovations typically take 2-4 weeks, while new construction can take 3-6 months. We provide detailed timelines during consultation.",
            },
            {
              question: "Do you provide free estimates?",
              answer:
                "Yes! We offer free consultations and estimates for all projects. Our team will assess your needs and provide a detailed quote with no obligation.",
            },
            {
              question: "Are you licensed and insured?",
              answer:
                "Absolutely. We are fully licensed, bonded, and insured. All our work comes with comprehensive warranties and we maintain all required certifications.",
            },
            {
              question: "What areas do you serve?",
              answer:
                "We serve the entire metropolitan area and surrounding suburbs within a 50-mile radius. Contact us to confirm service availability in your specific location.",
            },
          ].map((faq, index) => (
            <div
              key={index}
              className="bg-white p-6 rounded-lg shadow-md"
              data-aos="fade-up"
              data-aos-delay={index * 100}
            >
              <h4 className="text-lg font-semibold mb-2">{faq.question}</h4>
              <p className="text-gray-600">{faq.answer}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
